// RequestsComponent.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Requests = () => {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch all requests with user information
        const response = await axios.post('https://pgdost.onrender.com/api/all-requests', {
          email: localStorage.getItem('email'),
        });
  
        // Update the local state with the fetched requests
        setRequests(response.data.requests);
      } catch (error) {
        console.error('Error fetching requests:', error);
      }
    };
  
    // Fetch room status
    // Fetch requests
    fetchData();
  }, []); //

  const handleApprove = async (requestId) => {
    try {
      // Implement logic to approve the request
      const response = await axios.put('https://pgdost.onrender.com/api/respond-to-request', {
        requestId,
        response: 'approved',
      });
  
      // Update the local state with the new status
      setRequests(requests.map(req => (req.requestId === requestId ? { ...req, status: response.data.status } : req)));
    } catch (error) {
      console.error('Error approving request:', error);
    }
  };
  
  const handleReject = async (requestId) => {
    try {
      // Implement logic to reject the request
      const response = await axios.put('https://pgdost.onrender.com/api/respond-to-request', {
        requestId,
        response: 'rejected',
      });
  
      // Update the local state with the new status
      setRequests(requests.map(req => (req.requestId === requestId ? { ...req, status: response.data.status } : req)));
    } catch (error) {
      console.error('Error rejecting request:', error);
    }
  };
  

  return (
    <div className="container mx-auto my-8">
      <h2 className="text-3xl font-semibold mb-4">All Requests</h2>
      <ul>
        
        {requests.length!=0?requests.map(request => (
          
          <li key={request.requestId} className="bg-gray-100 p-4 mb-4 flex justify-between items-center">
            <div>
              <img src={request.user.profilePic} alt="Profile Pic" className="w-16 h-16 rounded-full" />
              <p className="text-lg font-semibold">Name: {request.user.name}</p>
              <p> Course Name: {request.user.courseName}</p>
              <p>Course Code: {request.user.courseCode}</p>
              <p>Semester: {request.user.semester}</p>
              {/* Add other user information fields */}
            </div>
            <div>
              <p className="text-lg font-semibold">Status: {request.status}</p>
              {request.status === 'pending' && (
                <div className="flex space-x-4">
                  <button onClick={() => handleApprove(request.requestId)} className="bg-green-500 text-white px-4 py-2 rounded">
                    Approve
                  </button>
                  <button onClick={() => handleReject(request.requestId)} className="bg-red-500 text-white px-4 py-2 rounded">
                    Reject
                  </button>
                </div>
              )}
            </div>
          </li>
              
        )):<>
         <div className="w-full flex items-center justify-center h-64 text-3xl ">
          No Requests here :(
        </div>
        
        </>}
      </ul>
    </div>
  );
};

export default Requests;
